<template>
	<div class="requirements">
		<span v-if="prefix" class="prefix">{{ prefix }}</span>
		<ul>
			<li
				v-for="requirement in requirements"
				:key="requirement.key"
				:class="{'valid': requirement.valid}"
			>
				<Icon :icon="requirement.valid ? 'checkmark' : 'close'"/>
				<span>{{ requirement.label }}</span>
			</li>
		</ul>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon"

export default {

	components: {
		Icon,
	},

	props: {
		requirements: {
			type: Array,
			required: true,
		},
		prefix: {
			type: String,
			required: false,
		}
	},
}
</script>
